import React from 'react';
import { useSwiper } from '../hooks/useSwiper';
import TestiBox from './TestiBox';
import { useTranslation } from 'react-i18next';

const TestiSecTwo = ({ className }) => {
    const swiperRef = useSwiper();
    const { t } = useTranslation();

    return (
    <section className={className}>
        <div className="shape-mockup bg-gradient-shape1" data-top="10%" data-left="3%"></div>
        <div className="container">
            <div className="row justify-content-center">
            <div className="col-12">
                <div className="title-area text-center">
                <span className="sub-title style2" data-cue="slideInUp">{t('sections.testimonialSecOne.sub_title','Testimonial')}</span>
                <h2 className="sec-title" data-cue="slideInUp">{t('sections.testimonialSecOne.title','What Our Customers Say')}</h2>
                </div>
            </div>
            </div>
            <div className="slider-area testi-slider2">
            <div 
                ref={swiperRef}
                className="swiper ot-react-slider" data-cue="slideInUp" id="testiSlider2" data-slider-options='{"loop":false,"autoHeight": true,"breakpoints":{"0":{"slidesPerView":1},"768":{"slidesPerView":"2"},"1200":{"slidesPerView":"3"}}}'
            >
                <div className="swiper-wrapper">
                    <TestiBox className="swiper-slide" limit={6} />
                </div>
                <div className="slider-pagination"></div>
            </div>
            </div>
        </div>
    </section>
  );
};

export default TestiSecTwo;